import { apiFetch } from '../api-client';

export interface QcctRate {
  id: string;
  nhom: number;
  vung: 'HN_HCM' | 'TinhI' | 'TinhKhac' | 'Foreign';
  lodging: number;
  perDiem: number;
  travel: number;
}
export const qcctRatesApi = {
  list: () => apiFetch<{ items: QcctRate[] }>('/api/qcct-rates'),
  patch: (id: string, body: Partial<Pick<QcctRate, 'lodging' | 'perDiem' | 'travel'>>) =>
    apiFetch<QcctRate>(`/api/qcct-rates/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
};
